import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import {
  ArrowRightIcon,
  PlusIcon,
  QrCodeIcon,
  RectangleStackIcon,
  SparklesIcon
} from '@heroicons/react/24/outline';
import './MemberWelcomeBar.css';
import { hasValidAuthentication } from '../../services/auth';

const MemberWelcomeBar = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const currentLang = location.pathname.split('/')[1] || 'mk';
  const [userName, setUserName] = useState('');

  useEffect(() => {
    const syncMember = () => {
      const fullName = localStorage.getItem('userFullName');
      setUserName(hasValidAuthentication() ? (fullName || t('memberWelcome.userFallback')) : '');
    };

    syncMember();
    window.addEventListener('storage', syncMember);
    window.addEventListener('authChange', syncMember);
    return () => {
      window.removeEventListener('storage', syncMember);
      window.removeEventListener('authChange', syncMember);
    };
  }, [t]);

  if (!userName) {
    return null;
  }

  return (
    <section className="member-bar" data-testid="logged-in-welcome-section">
      <div className="member-bar-inner">
        <div className="member-bar-greeting">
          <span className="member-bar-spark" aria-hidden="true">
            <SparklesIcon />
          </span>
          <div>
            <p className="member-bar-eyebrow">{t('memberWelcome.eyebrow')}</p>
            <h1 data-testid="logged-in-welcome-greeting">
              {t('memberWelcome.greeting', { name: userName })}
            </h1>
            {t('memberWelcome.prompt', { defaultValue: '' }) && <p>{t('memberWelcome.prompt', { defaultValue: '' })}</p>}
          </div>
        </div>

        <nav
          className="member-bar-actions"
          aria-label={t('memberWelcome.actionsLabel')}
          data-testid="logged-in-welcome-actions"
        >
          <Link
            to={`/${currentLang}/products`}
            className="member-quick-action member-quick-action-order"
            data-testid="logged-in-order-qr-plate-button"
          >
            <span className="member-quick-icon" aria-hidden="true"><QrCodeIcon /></span>
            <span>{t('memberWelcome.orderPlate')}</span>
            <ArrowRightIcon className="member-quick-arrow" aria-hidden="true" />
          </Link>

          <Link
            to={`/${currentLang}/create-profile`}
            className="member-quick-action member-quick-action-create"
            data-testid="logged-in-create-profile-button"
          >
            <span className="member-quick-icon" aria-hidden="true"><PlusIcon /></span>
            <span>{t('memberWelcome.createProfile')}</span>
          </Link>

          <Link
            to={`/${currentLang}/my-profile`}
            className="member-quick-action member-quick-action-manage"
            data-testid="logged-in-manage-profiles-button"
          >
            <span className="member-quick-icon" aria-hidden="true"><RectangleStackIcon /></span>
            <span>{t('memberWelcome.manageProfiles')}</span>
          </Link>
        </nav>
      </div>
    </section>
  );
};

export default MemberWelcomeBar;
